import axios from 'axios';
import config from '../config';

// Create Razorpay order
const createRazorpayOrder = async (amount) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(`${config.apiUrl}payments/razorpay/order`,
            { amount },
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );

        if (response.status === 200) {
            const order = response.data.order;  // Access `order` object properly
            return {
                status: 200,
                orderId: order.id,
                amount: order.amount,
                currency: order.currency
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response?.data?.message || "Something went wrong"
        };
    }
}

//update status, payment referecence, payment date time by batchstudentpayment id
const UpdatePaymentDetails = async (batchStudentPaymentId, status, paymentReference, paymentDateTime) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(`${config.apiUrl}batchStudentPayments/update/${batchStudentPaymentId}`,
            {
                status,
                paymentReference,
                paymentDateTime
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );

        if (response.status === 200) {
            return {
                status: 200,
                message: "Payment details updated successfully"
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response?.data?.message || "Failed to update payment details"
        };
    }
}

//get batchstudentpayments by userId with pagination, total overall fees, total paid, total pending
const GetBatchStudentPayments = async (userId, page, limit) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            `${config.apiUrl}batchStudentPayments/byUser/${userId}`, {
            params: {
                page,
                limit
            },
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }
        );

        if (response.status === 200 && response.data.success) {
            const data = response.data.data; // <-- access the data object from backend

            return {
                status: 200,
                payments: data.payments,
                pagination: {
                    currentPage: data.currentPage,
                    totalPages: data.totalPages,
                    totalItems: data.totalItems
                },
                summary: {
                    totalFees: data.totalFees,
                    totalPaid: data.totalPaid,
                    totalPending: data.totalPending
                }
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response?.data?.message || "Failed to fetch payment details"
        };
    }
}

//Get collection reports with date and batch filters
const GetCollectionReportsByUserId = async (fromDate, toDate, batchId, userId, page, limit) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}batchStudentPayments/collection-report-by-user?fromDate=${fromDate}&toDate=${toDate}&batchId=${batchId}&userId=${userId}&page=${page}&limit=${limit}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

        if (response.status === 200) {
            const d = response.data.data; // ✅ correct level
            return {
                status: 200,
                message: response.data.message,
                collections: d.collections,
                totalItems: d.totalItems,
                totalPages: d.totalPages,
                currentPage: d.currentPage,
                totalAmount: d.summary?.totalAmount || 0,
                receivedAmount: d.summary?.receivedAmount || 0,
                pendingAmount: d.summary?.pendingAmount || 0
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

//Get pending reports with date and batch filters
const GetPendingReportsByUserId = async (fromDate, toDate, batchId, userId, page, limit) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}batchStudentPayments/pending-report-by-user?fromDate=${fromDate}&toDate=${toDate}&batchId=${batchId}&userId=${userId}&page=${page}&limit=${limit}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

        if (response.status === 200) {
            const d = response.data.data;
            return {
                status: 200,
                message: response.data.message,
                collections: d.collections,
                totalItems: d.totalItems,
                totalPages: d.totalPages,
                currentPage: d.currentPage,
                totalAmount: d.summary?.totalAmount || 0,
                receivedAmount: d.summary?.receivedAmount || 0,
                pendingAmount: d.summary?.pendingAmount || 0
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

//get batchstudentpayemts by batchStudentId with pagination
const GetPaymentsByBatchStudentId = async (batchStudentId, page, limit) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}batchStudentPayments/byStudent/${batchStudentId}?page=${page}&limit=${limit}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

        if (response.status === 200) {
            const d = response.data.data;
            return {
                status: 200,
                message: response.data.message,
                payments: d.payments,
                totalItems: d.totalItems,
                totalPages: d.totalPages,
                currentPage: d.currentPage,
                amount: d.amount,
                totalPaid: d.totalPaid,
                totalPending: d.totalPending,
                totalFee: d.totalFee,

                //added batchwise summary              
                batchStats: {
                    noOfStudents: d.batchStats?.noOfStudents || 0,
                    totalToBeReceived: d.batchStats?.totalToBeReceived || 0,
                    totalReceived: d.batchStats?.totalReceived || 0,
                    totalPending: d.batchStats?.pendingBalance || 0
                }
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}


//get GetMonthlySummaryReport by month, year
const GetMonthlySummaryReportByUserId = async (month, year, userId) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            `${config.apiUrl}batchStudentPayments/monthly-summary-by-user?month=${month}&year=${year}&userId=${userId}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
        console.log("ddD", response);

        if (response.status === 200) {
            const d = response.data.data;

            return {
                status: 200,
                message: response.data.message,
                summary: d?.batches || [],
                overall: {
                    totalFee: d?.overallTotalFee || 0,
                    totalPaid: d?.overallTotalPaid || 0,
                    totalPending: d?.overallTotalPending || 0
                }
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error?.response?.data?.message || "Something went wrong"
        };
    }
};




export { createRazorpayOrder, UpdatePaymentDetails, GetBatchStudentPayments, GetCollectionReportsByUserId, GetPendingReportsByUserId, GetPaymentsByBatchStudentId, GetMonthlySummaryReportByUserId };


